import { FC, useEffect, useState } from 'react';
import { Typography, Box, Button } from '@mui/material';

import { Post } from '@libs/models';
import { PostStatus } from '@libs/types';
import { isActive, isClosed, isExpired, isInFuture, isInPastOrToday, isPending } from '@carcareers/utils';
import { usePost } from '@carcareers/hooks';

interface PostActionsProps {
  post?: Post;
}

interface PostActions {
  none?: boolean;
  canClosePosting?: boolean;
  canStartPosting?: boolean;
}

export const PostActions: FC<PostActionsProps> = ({ post }) => {
  const status = post?.status as PostStatus;
  const [actions, setActions] = useState<PostActions>({});
  const { startPost, closePost } = usePost();

  useEffect(() => {
    setActions({
      none: isClosed(status) || isExpired(status),
      canClosePosting: isActive(status) && isInPastOrToday(post?.startDate),
      canStartPosting: isPending(status) && isInFuture(post?.endDate),
    });
  }, [status, post?.startDate, post?.endDate]);

  if (actions.none || !post) {
    return null;
  }

  return (
    <>
      <Typography variant="h5" sx={{ my: 2 }}>
        Actions
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
        {actions.canClosePosting && (
          <Button
            variant="contained"
            color="secondary"
            onClick={async () => await closePost(post)}
            size="large"
          >
            Close Posting
          </Button>
        )}
        {actions.canStartPosting && (
          <Button
            variant="contained"
            color="secondary"
            onClick={async () => await startPost(post)}
            size="large"
          >
            Start Posting
          </Button>
        )}
      </Box>
    </>
  );
};
